/** Invest Ottawa hub locations shown on the post-gate landing page. */
export const HUB_LOCATION_SLUGS = ['bayviewyards', 'killaloe', 'areaxo'] as const;

export type HubLocationSlug = (typeof HUB_LOCATION_SLUGS)[number];

export const HUB_LANDING_PATH = '/reception';

export function isHubLocationSlug(slug: string | null | undefined): slug is HubLocationSlug {
  if (!slug) return false;
  return (HUB_LOCATION_SLUGS as readonly string[]).includes(slug);
}

export function isHubLandingPath(pathname: string): boolean {
  return pathname === HUB_LANDING_PATH || pathname === '/dashboard';
}

/** Sort hub locations in the canonical sidebar / landing order. */
export function sortHubLocations<T extends { slug?: string | null }>(locations: T[]): T[] {
  const order = new Map<string, number>(
    HUB_LOCATION_SLUGS.map((slug, i) => [slug, i])
  );
  return [...locations].sort((a, b) => {
    const ai = order.get(a.slug ?? '') ?? 999;
    const bi = order.get(b.slug ?? '') ?? 999;
    return ai - bi;
  });
}
